var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ExcelFileAssetIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 43,
    glyphHeight: 60
  }), React.createElement("path", {
    d: "M12.8472 0.782593L0.325439 13.3043V59.2174H42.0646V0.782593H12.8472ZM37.8907 55.0435H4.49935V13.3043H12.8472V4.95651H37.8907V55.0435Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M29.1211 36.1681C28.2625 36.1681 27.5345 36.0234 26.9371 35.7341C26.3398 35.4354 25.8311 35.0527 25.4111 34.5861L26.8111 33.1721C27.4738 33.9187 28.2905 34.2921 29.2611 34.2921C29.7838 34.2921 30.1711 34.1847 30.4231 33.9701C30.6751 33.7554 30.8011 33.4707 30.8011 33.1161C30.8011 32.8454 30.7265 32.6214 30.5771 32.4441C30.4278 32.2574 30.1245 32.1314 29.6671 32.0661L28.7011 31.9401C27.6651 31.8094 26.9045 31.4967 26.4191 31.0021C25.9431 30.5074 25.7051 29.8494 25.7051 29.0281C25.7051 28.5894 25.7891 28.1881 25.9571 27.8241C26.1251 27.4601 26.3631 27.1474 26.6711 26.8861C26.9885 26.6247 27.3711 26.4241 27.8191 26.2841C28.2765 26.1347 28.7945 26.0601 29.3731 26.0601C30.1105 26.0601 30.7591 26.1767 31.3191 26.4101C31.8791 26.6434 32.3598 26.9841 32.7611 27.4321L31.3471 28.8601C31.1138 28.5894 30.8291 28.3701 30.4931 28.2021C30.1665 28.0247 29.7511 27.9361 29.2471 27.9361C28.7711 27.9361 28.4165 28.0201 28.1831 28.1881C27.9498 28.3561 27.8331 28.5894 27.8331 28.8881C27.8331 29.2241 27.9218 29.4667 28.0991 29.6161C28.2858 29.7654 28.5845 29.8727 28.9951 29.9381L29.9611 30.0921C30.9691 30.2507 31.7158 30.5634 32.2011 31.0301C32.6865 31.4874 32.9291 32.1407 32.9291 32.9901C32.9291 33.4567 32.8451 33.8861 32.6771 34.2781C32.5091 34.6701 32.2618 35.0061 31.9351 35.2861C31.6178 35.5661 31.2211 35.7854 30.7451 35.9441C30.2691 36.0934 29.7278 36.1681 29.1211 36.1681Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M18.5332 36V26.228H20.6612V34.11H24.3852V36H18.5332Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M17.2335 36H14.7695L12.6555 32.402H12.6135L10.5555 36H8.25952L11.3955 30.946L8.41352 26.228H10.8915L12.7955 29.532H12.8375L14.7695 26.228H17.0655L14.0555 30.988L17.2335 36Z",
    fill: "black"
  }));
};
export var ExcelFileAssetIconGlyph = function (props) {
  return React.createElement(ExcelFileAssetIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};